import { Page } from "../../types/Page";
import { PageAction, PageActionType } from "../actions/pageAction";

const initialState: Page[] = [];

export const pageReducer = (
  state = initialState,
  action: PageAction,
): Page[] => {
  switch (action.type) {
    case PageActionType.FETCH_PAGES:
      return action.data;
    case PageActionType.FETCH_PAGES_PROJECTID:
      return action.data;
    case PageActionType.ADD_PAGE:
      return [...state, action.data];
    case PageActionType.EDIT_PAGE:
      return state.map((pg) => (pg.id === action.data.id ? action.data : pg));
    case PageActionType.DELETE_PAGE:
      return state.filter((pg) => pg.id !== action.data);
    default:
      return state;
  }
};
